import styled from 'foundations-theming/utils';
import { filterTokenProps } from '../../../utils/filterTokenProps';
import { useMapTokenPropsToCSS } from '../../../hooks/useMapTokenPropsToCSS';
import { jsx as _jsx } from "react/jsx-runtime";
const StyledLabel = styled.label.withConfig({
  displayName: "WellBigNumber__StyledLabel"
})(({
  $cssStyles,
  theme
}) => {
  return Object.assign({
    // hardcoding values
    fontWeight: '400',
    fontSize: '28px',
    lineHeight: '36px',
    letterSpacing: '0%',
    // hardcoding values
    display: 'inline-block',
    marginBottom: theme.space['0'],
    verticalAlign: 'baseline'
  }, $cssStyles);
});
export const WellBigNumber = props => {
  const {
    tokenProps,
    restProps
  } = filterTokenProps(props);
  const cssStyles = useMapTokenPropsToCSS(tokenProps);
  return /*#__PURE__*/_jsx(StyledLabel, Object.assign({
    $cssStyles: cssStyles
  }, restProps));
};